export const CORE_TYPE_RELEASE = '0.0.4-2209111843'
